import { Button, Row, Tab, Tabs } from '@themesberg/react-bootstrap'
import React, { useState } from 'react'
import MultiLanguage from './MultiLanguage'
import { languageCode } from '../../../../Tenant/TenantConfigurations/Languages/constants'
import Trigger from '../../../../../components/OverlayTrigger'

const Languages = ({
  languages,
  handleSubmit,
  setSelectedTab,
  data,
  setData
}) => {
  const [selectedLang, setSelectedLang] = useState(languages?.[0] || '')

  const checkAllEmptyCondition = () => {
    return ((data?.promoTitle?.[selectedLang] === '' || data?.promoTitle?.[selectedLang] === undefined) &&
    (data?.desc?.[selectedLang] === '' ||
    data?.desc?.[selectedLang] === undefined ||
    (data?.desc?.[selectedLang] && (!data?.desc?.[selectedLang]?.replace(/<[^>]+>/g, '')?.length))
    ) &&
    (data?.terms?.[selectedLang] === '' ||
    data?.terms?.[selectedLang] === undefined ||
    (data?.terms?.[selectedLang] && (!data?.terms?.[selectedLang]?.replace(/<[^>]+>/g, '')?.length))
    ))
  }

  const checkAllFilled = () => {
    return (data?.promoTitle?.[selectedLang] &&
      (data?.desc?.[selectedLang] && (data?.desc?.[selectedLang]?.replace(/<[^>]+>/g, '')?.length)) &&
      (data?.terms?.[selectedLang] && (data?.terms?.[selectedLang]?.replace(/<[^>]+>/g, '')?.length)))
  }

  return (
    <>
      <Row className='text-danger'>
        <strong>
          All fields are required or cleared before switching to another language or moving Previous or Next/Submit.
        </strong>
      </Row>
      <Tabs
        activeKey={selectedLang}
        onSelect={(tab) => setSelectedLang(tab)}
        className='nav-light mt-3'
        mountOnEnter
        unmountOnExit
      >
        {languages?.length && languages?.map((code) => {
          return code !== 'EN' && (
            <Tab
              eventKey={code}
              title={
                <Trigger message={languageCode[code]}>
                  <span>{code}</span>
                </Trigger>
                }
              key={code}
              mountOnEnter
              disabled={!(checkAllFilled() || checkAllEmptyCondition())}
              tabClassName={selectedLang !== code ? (data?.promoTitle?.[code] !== undefined && data?.promoTitle?.[code] !== '') ? 'email' : '' : 'email-active'}
            >
              <div className='mt-5'>
                <MultiLanguage
                  selectedLang={selectedLang}
                  data={data}
                  setData={setData}
                />
              </div>
            </Tab>
          )
        })}
      </Tabs>
      <div className='mt-3 d-flex justify-content-between'>
        <Button
          variant='outline-warning'
          onClick={() => setSelectedTab('general')}
          disabled={!(checkAllFilled() || checkAllEmptyCondition())}
        >Previous
        </Button>
        <Button
          variant='outline-success'
          onClick={handleSubmit}
          disabled={!(checkAllFilled() || checkAllEmptyCondition())}
        >Next
        </Button>
      </div>
    </>
  )
}

export default Languages
